if (import.meta.hot) {
	import.meta.hot.accept();
}

import 'jquery';
import 'jquery-ui-bundle';

import App from "@templates/App/App.js";

App.init();
